module.exports = __webpack_public_path__ + "assets/img/30fcfbeedb2e7bc89836f221f5e619ce.svg";